import { render, staticRenderFns } from "./FixedBenefitModal.vue?vue&type=template&id=347fe08a"
import script from "./FixedBenefitModal.vue?vue&type=script&lang=js"
export * from "./FixedBenefitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports